import { useEffect, useRef, useState } from "react";

/**
 * useScreenWidth
 * Efficiently tracks window.innerWidth with rAF-coalesced resize handling.
 */
export default function useScreenWidth() {
  //#region State & refs
  const [screenWidth, setScreenWidth] = useState(() => window.innerWidth);
  const rafIdRef = useRef(0);
  const lastWidthRef = useRef(screenWidth);
  //#endregion

  //#region Effect: subscribe to resize (passive) and coalesce updates
  useEffect(() => {
    const onResize = () => {
      if (rafIdRef.current) return;
      rafIdRef.current = requestAnimationFrame(() => {
        rafIdRef.current = 0;
        const newWidth = window.innerWidth;
        if (newWidth !== lastWidthRef.current) {
          lastWidthRef.current = newWidth;
          setScreenWidth(newWidth);
        }
      });
    };
    window.addEventListener("resize", onResize, { passive: true });
    return () => {
      window.removeEventListener("resize", onResize);
      if (rafIdRef.current) cancelAnimationFrame(rafIdRef.current);
    };
  }, []);
  //#endregion

  return screenWidth;
}
